const routes = [
	{
		path: '/',
		component: () => import('layouts/WebLayout.vue'),
		children: [
			{ path: '', component: () => import('src/pages/web/Index.vue') },
			{ path: 'about', component: () => import('src/pages/web/About.vue'), meta: { backButton: true } },
			{ path: 'campaign', component: () => import('src/pages/web/Campaign.vue'), meta: { backButton: true } },
			{ path: 'privacy-policy', component: () => import('src/pages/PrivacyPolicy.vue'), meta: { backButton: true } },
			{ path: 'term-and-conditions', component: () => import('src/pages/TermNConditions.vue'), meta: { backButton: true } },
			{ path: 'community-guidelines', component: () => import('src/pages/CommunityGuidelines.vue'), meta: { backButton: true } },
			{ path: 'roadmap', component: () => import('src/pages/web/RoadMap.vue'), meta: { backButton: true } }
		]
	},
	{
		path: '/',
		component: () => import('layouts/MainLayout.vue'),
		meta: { roles: ['*'] },
		children: [
			{ path: 'home', component: () => import('src/pages/Home.vue') },
			{ path: 'dashboard', component: () => import('src/pages/dashboard/Index.vue') },
			{ path: 'dashboard/summary/:kind/:type', component: () => import('src/pages/dashboard/Summary.vue'), meta: { backButton: true } },
			{ path: 'dashboard/summary/heart/:type/:category', component: () => import('src/pages/dashboard/Heart.vue'), meta: { backButton: true } },
			{ path: 'dashboard/summary/body/:type/:category', component: () => import('src/pages/dashboard/Body.vue'), meta: { backButton: true } },
			{ path: 'user/profile', component: () => import('pages/user/Profile.vue') },
			{ path: 'user/password', component: () => import('pages/user/ChangePassword.vue') },
			{ path: 'report/violation', component: () => import('pages/ReportViolation.vue') },
			{ path: 'connect/:user', component: () => import('src/pages/friend/Connect.vue'), meta: { backButton: true } },
			{ path: 'connect/inner/:user', component: () => import('src/pages/friend/ConnectInner.vue'), meta: { backButton: true } },
			{ path: 'profile/:user?', component: () => import('src/pages/Profile.vue') },
			{ path: 'realfren', component: () => import('src/pages/Realfren.vue') },
			{ path: 'settings', component: () => import('pages/Setting.vue') },
			{ path: 'user/info', component: () => import('pages/user/Information.vue') },
			{ path: 'inner/form', component: () => import('src/pages/friend/InnerForm.vue') },
			{ path: 'inner/form/:username', component: () => import('src/pages/friend/InnerFormDisplay.vue'), meta: { backButton: true } },
			{ path: 'friend/inner/request', component: () => import('pages/friend/Request.vue'), meta: { backButton: true } },
			{ path: 'friend/inner/request/:id', component: () => import('pages/friend/RequestDetail.vue') },
			{ path: 'friend/:type/:id?', component: () => import('pages/friend/List.vue') },
			{ path: 'messages', component: () => import('src/pages/messaging/Index.vue') },
			{ path: 'messages/web', component: () => import('src/pages/messaging/Web.vue') },
			{ path: 'messages/mobile', component: () => import('src/pages/messaging/Mobile.vue') },
			{ path: 'reminders', component: () => import('src/pages/Reminders.vue') },
			{ path: 'hangout', component: () => import('src/pages/hangout/My.vue') },
			{ path: 'hangout/:id', component: () => import('src/pages/hangout/Form.vue') },
			{ path: 'hangout/detail/:id', component: () => import('src/pages/hangout/Read.vue'), meta: { backButton: true } },
			{ path: 'hangouts/:username?', component: () => import('src/pages/hangout/List.vue'), meta: { backButton: true } },
			{ path: 'explore/hangout', component: () => import('src/pages/hangout/Feature.vue') },
			{ path: 'explore/realfriend', component: () => import('src/pages/hangout/Find.vue') },
			{ path: 'explore/detail/:user', component: () => import('src/pages/hangout/Explore.vue'), meta: { backButton: true } },
			{ path: 'explore/summary/:user', component: () => import('src/pages/hangout/Summary.vue'), meta: { backButton: true } },
			{ path: 'notifications', component: () => import('src/pages/notification/Index.vue') },
			{ path: 'notification/:id', component: () => import('src/pages/notification/Read.vue') },
			{ path: 'recalibrating/habits', component: () => import('src/pages/tools/habit/Index.vue') },
			{ path: 'recalibrating/habits/:id', component: () => import('src/pages/tools/habit/Form.vue') },
			{ path: 'recalibrating/habits/private/:id', component: () => import('src/pages/tools/habit/Form.vue') },
			{ path: 'recalibrating/habits/daily/:id/:date', component: () => import('src/pages/tools/habit/Daily.vue') },
			{ path: 'recalibrating/habits/daily/:id/:date/:type', component: () => import('src/pages/tools/habit/Daily.vue') },
			{ path: 'recalibrating/habits/log/:id', component: () => import('src/pages/tools/habit/Log.vue'), meta: { backButton: true } },
			{ path: 'blocked/user', component: () => import('src/pages/friend/Blocked.vue'), meta: { backButton: true } },
			{ path: 'user/whoop', component: () => import('src/pages/user/ConnectWhoop.vue'), meta: { backButton: true } }
		]
	},
	{
		path: '/admin',
		component: () => import('layouts/AdminLayout.vue'),
		meta: { roles: ['Admin'] },
		children: [
			{ path: 'report/violation', component: () => import('pages/admin/report-violation/View.vue') },
			{ path: 'report/violation/:id', component: () => import('pages/admin/report-violation/Form.vue') }
		]
	},
	{
		path: '/configuration',
		component: () => import('layouts/AdminLayout.vue'),
		meta: { roles: ['Admin'] },
		children: [
			{ path: 'user', component: () => import('pages/configurations/user/View.vue') },
			{ path: 'user/:id', component: () => import('pages/configurations/user/Form.vue') },
			{ path: 'parameter', component: () => import('pages/configurations/parameter/View.vue') },
			{ path: 'parameter/:id', component: () => import('pages/configurations/parameter/Form.vue') }
		]
	},
	{ path: '/signin/:email?/:code?', component: () => import('src/pages/SignIn.vue') },
	{ path: '/oauth/callback', component: () => import('src/pages/OAuthCallback.vue') },
	{
		path: '/:catchAll(.*)*',
		component: () => import('pages/Error404.vue')
	}
];

export default routes;
